module.exports = __webpack_public_path__ + "static/media/vision.861e3381.svg";